
// Product Bundle Customization Handler
class ProductBundleCustomizationHandler {
  constructor() {
    this.currentStep = 1;
    this.totalSteps = 3;
    this.init();
  }

  init() {
    // Ensure bundle container exists before proceeding
    const bundleContainer = document.querySelector('.product-bundle');
    if (!bundleContainer) {
      console.log('No product bundle found on this page');
      return;
    }

    // Initialize step wizard first thing
    this.initializeStepWizard();

    // Listen for parent product variant changes
    this.initializeParentVariantListener();

    // Handle customization checkbox changes
    document.addEventListener('change', (e) => {
      if (e.target.classList.contains('bundle-customization-checkbox')) {
        this.toggleCustomizationOptions(e.target);
        this.updateAddToCartButtonState();
        this.updateBundleSummary();
      }
    });

    // Handle regular bundle checkbox changes
    document.addEventListener('change', (e) => {
      if (e.target.classList.contains('bundle-product-checkbox')) {
        this.toggleBundleOptions(e.target);
        this.updateAddToCartButtonState();
        this.updateBundleSummary();
      }
    });

    // Handle font selection changes
    document.addEventListener('change', (e) => {
      if (e.target.classList.contains('product-bundle__font-select')) {
        this.updateCustomizationData(e.target);
        this.updateBundleSummary();
      }
    });

    // Handle thread color selection changes
    document.addEventListener('change', (e) => {
      if (e.target.classList.contains('product-bundle__thread-color-input')) {
        this.updateCustomizationData(e.target);
        this.updateBundleSummary();
      }
    });

    // Handle variant selection changes
    document.addEventListener('change', (e) => {
      if (e.target.classList.contains('product-bundle__variant-select')) {
        this.updateCustomizationData(e.target);
        this.updateAddToCartButtonState();
        this.updateBundleSummary();

        // Clear validation error when variant is selected
        const step = e.target.closest('.product-bundle__step');
        if (step) {
          this.hideStepValidationError(step);
        }
      }
    });

    // Handle product options selection changes
    document.addEventListener('change', (e) => {
      if (e.target.classList.contains('product-bundle__product-select')) {
        this.handleProductSelection(e.target);
        this.updateBundleSummary();
        this.updateAddToCartButtonState(); // Enable button when product is selected

        // Clear validation error when product is selected
        const step = e.target.closest('.product-bundle__step');
        if (step) {
          this.hideStepValidationError(step);
        }
      }
    });

    // Handle product selection to auto-mark as selected
    // Items are now automatically included when selected, no checkbox needed

    // Handle thread color changes in product options
    document.addEventListener('change', (e) => {
      if (e.target.classList.contains('product-bundle__thread-color-input') &&
          e.target.dataset.optionGroup) {
        this.updateAddToCartButtonState();
      }
    });

    // Handle icon selection changes
    document.addEventListener('change', (e) => {
      if (e.target.classList.contains('product-bundle__icon-input')) {
        const iconPrice = parseInt(e.target.dataset.iconPrice) || 0;
        console.log('Icon selected:', {
          value: e.target.value,
          checked: e.target.checked,
          id: e.target.id,
          iconPrice: iconPrice,
          autoAddQuantity: iconPrice
        });
        this.updateAddToCartButtonState();
        this.updateBundleSummary();
      }
    });

    // Handle thread icon selection changes (no cost)
    document.addEventListener('change', (e) => {
      if (e.target.classList.contains('product-bundle__thread-icon-input')) {
        console.log('Thread icon selected:', {
          value: e.target.value,
          checked: e.target.checked,
          id: e.target.id
        });
        this.updateBundleSummary();
      }
    });

    // Handle personalization input changes
    document.addEventListener('input', (e) => {
      if (e.target.classList.contains('product-bundle__personalization-input')) {
        this.handlePersonalizationInput(e.target);
        this.updateBundleSummary();
      }
    });

    // Handle date/extra data input changes
    document.addEventListener('input', (e) => {
      if (e.target.classList.contains('product-bundle__date-extra-input')) {
        this.handleDateExtraInput(e.target);
        this.updateBundleSummary();
      }
    });

    // Handle font selection changes
    document.addEventListener('change', (e) => {
      if (e.target.classList.contains('product-bundle__font-select')) {
        this.updateBundleSummary();
      }
    });

    // Handle position selection changes
    document.addEventListener('change', (e) => {
      if (e.target.classList.contains('product-bundle__position-select')) {
        this.updateBundleSummary();
      }
    });

    // Handle name option input changes
    document.addEventListener('input', (e) => {
      if (e.target.classList.contains('product-bundle__name-option-input')) {
        this.updateBundleSummary();
      }
    });

    // Handle initial input changes
    document.addEventListener('input', (e) => {
      if (e.target.classList.contains('product-bundle__initial-input')) {
        this.updateBundleSummary();
      }
    });

    // Handle product dropdown selection
    document.addEventListener('change', (e) => {
      if (e.target.classList.contains('product-bundle__product-dropdown')) {
        this.selectProductFromDropdown(e.target);
      }
    });

    // Handle variant selection changes for step_1
    document.addEventListener('change', (e) => {
      if (e.target.classList.contains('product-bundle__variant-select-step1')) {
        const optionGroup = e.target.dataset.optionGroup;
        const selectedOption = e.target.options[e.target.selectedIndex];
        const newPrice = selectedOption.dataset.price;

        // Update price display
        const selectedProductDiv = document.querySelector(`[data-option-group="${optionGroup}"].product-bundle__selected-product`);
        if (selectedProductDiv) {
          const priceElement = selectedProductDiv.querySelector('.product-bundle__selected-product-price');
          if (priceElement && newPrice) {
            priceElement.textContent = this.formatPrice(newPrice);
          }
        }

        // Update bundle summary
        this.updateBundleSummary();

        // Clear validation error when variant is selected
        const step = e.target.closest('.product-bundle__step');
        if (step) {
          this.hideStepValidationError(step);
        }
      }
    });

    // Handle step navigation buttons
    document.addEventListener('click', (e) => {
      if (e.target.classList.contains('product-bundle__step-next') ||
          e.target.closest('.product-bundle__step-next')) {
        this.goToNextStep();
      }
      if (e.target.classList.contains('product-bundle__step-prev') ||
          e.target.closest('.product-bundle__step-prev')) {
        this.goToPreviousStep();
      }
      if (e.target.classList.contains('product-bundle__step-review') ||
          e.target.closest('.product-bundle__step-review')) {
        this.showReviewStep();
      }
      if (e.target.classList.contains('product-bundle__back-to-steps') ||
          e.target.closest('.product-bundle__back-to-steps')) {
        this.backToSteps();
      }
    });


    // Handle add to cart button
    document.addEventListener('click', (e) => {
      if (e.target.classList.contains('product-bundle__add-all-btn')) {
        this.addSelectedItemsToCart(e.target);
      }
    });

    // Initialize button state on page load (with small delay to ensure DOM is ready)
    setTimeout(() => {
      this.updateAddToCartButtonState();
      this.updateBundleSummary();
    }, 100);

    // Also update button state when DOM is fully loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        this.updateAddToCartButtonState();
        this.initializeProductSelector();
        this.initializeProductDropdowns();
        this.updateBundleSummary();
      });
    } else {
      this.initializeProductSelector();
      this.initializeProductDropdowns();
      this.updateBundleSummary();
    }
  }

  // Initialize product dropdowns - ensure selectors are visible
  initializeProductDropdowns() {
    const bundleContainer = document.querySelector('.product-bundle');
    if (!bundleContainer) return;

    // Ensure all product selectors are visible (especially in step_1)
    const productSelectors = bundleContainer.querySelectorAll('.product-bundle__product-selector');
    productSelectors.forEach(selector => {
      // Force display the selector
      selector.style.display = 'block';
      selector.style.visibility = 'visible';
      selector.style.opacity = '1';
    });

    // Find all product select dropdowns
    const productSelects = bundleContainer.querySelectorAll('.product-bundle__product-select');

    productSelects.forEach(select => {
      const optionGroup = select.dataset.optionGroup;

      // Only auto-select if there's exactly one product option (not for step_1 with multiple products)
      if (select.options.length === 2) {
        // Auto-select if there's only one product option (plus placeholder)
        select.selectedIndex = 1;
        // Trigger the change event to show the product details
        this.handleProductSelection(select);
      }
    });
  }

  toggleCustomizationOptions(checkbox) {
    const productId = checkbox.dataset.productId;
    const optionsContainer = document.querySelector(`[data-product-id="${productId}"].product-bundle__customization-options`);

    if (optionsContainer) {
      if (checkbox.checked) {
        optionsContainer.style.display = 'block';
      } else {
        optionsContainer.style.display = 'none';
      }
    }
  }

  toggleBundleOptions(checkbox) {
    const productId = checkbox.dataset.productId;
    const optionsContainer = document.querySelector(`[data-product-id="${productId}"].product-bundle__variants`);

    if (optionsContainer) {
      if (checkbox.checked) {
        optionsContainer.style.display = 'block';
      } else {
        optionsContainer.style.display = 'none';
      }
    }
  }

  updateAddToCartButtonState() {
    const bundleContainer = document.querySelector('.product-bundle');
    if (!bundleContainer) return;

    const addToCartBtn = bundleContainer.querySelector('.product-bundle__add-all-btn');
    if (!addToCartBtn) return;

    // Check if any items are selected (products chosen from dropdowns)
    const regularCheckboxes = bundleContainer.querySelectorAll('.bundle-product-checkbox:checked');
    const customizationCheckboxes = bundleContainer.querySelectorAll('.bundle-customization-checkbox:checked');

    // Check for selected products (dropdown value is not empty)
    const productSelects = bundleContainer.querySelectorAll('.product-bundle__product-select');
    let selectedProducts = 0;
    productSelects.forEach(select => {
      if (select.value && select.value !== '') {
        selectedProducts++;
      }
    });

    const iconInputs = bundleContainer.querySelectorAll('.product-bundle__icon-input:checked');

    const hasSelectedItems = regularCheckboxes.length > 0 || customizationCheckboxes.length > 0 || selectedProducts > 0 || iconInputs.length > 0;

    // Debug logging (remove in production)
    console.log('Button state update:', {
      regularChecked: regularCheckboxes.length,
      customizationChecked: customizationCheckboxes.length,
      selectedProducts: selectedProducts,
      iconChecked: iconInputs.length,
      hasSelectedItems: hasSelectedItems,
      currentDisabled: addToCartBtn.disabled
    });


    // Enable/disable button based on selection
    addToCartBtn.disabled = !hasSelectedItems;

    // Update button text based on state
    if (hasSelectedItems) {
      addToCartBtn.textContent = 'Add to Cart';
    } else {
      addToCartBtn.textContent = 'Add to Cart';
    }
  }

  updateCustomizationData(element) {
    const productId = element.dataset.productId;
    const customizationData = this.getCustomizationData(productId);

    // Store customization data in a data attribute or custom event
    const productContainer = document.querySelector(`[data-product-id="${productId}"].product-bundle__customization-item`);
    if (productContainer) {
      productContainer.dataset.customizationData = JSON.stringify(customizationData);
    }

    // Dispatch custom event for other components to listen to
    const event = new CustomEvent('bundleCustomizationChanged', {
      detail: {
        productId: productId,
        customizationData: customizationData
      }
    });
    document.dispatchEvent(event);
  }

  getCustomizationData(productId) {
    const fontSelect = document.querySelector(`[data-product-id="${productId}"].product-bundle__font-select`);
    const threadColorInput = document.querySelector(`[data-product-id="${productId}"].product-bundle__thread-color-input:checked`);
    const quantityInput = document.querySelector(`[data-product-id="${productId}"].bundle-quantity-input`);
    const variantSelect = document.querySelector(`[data-product-id="${productId}"].product-bundle__variant-select`);

    return {
      font: fontSelect ? fontSelect.value : '',
      threadColor: threadColorInput ? threadColorInput.value : '',
      quantity: quantityInput ? parseInt(quantityInput.value) : 1,
      variantId: variantSelect ? variantSelect.value : ''
    };
  }


  async addSelectedItemsToCart(button) {
    const bundleContainer = button.closest('.product-bundle');
    if (!bundleContainer) return;

    // Disable button and show loading state
    button.disabled = true;
    button.textContent = 'Adding to Cart...';

    try {
      // Get parent variant ID BEFORE collecting items so it's available
      const parentVariantId = this.getParentVariantId(bundleContainer);

      if (!parentVariantId) {
        alert('Please select a product variant first.');
        button.disabled = false;
        button.textContent = 'Add Selected Items to Cart';
        return;
      }

      const selectedItems = this.collectSelectedItems(bundleContainer, parentVariantId);

      if (selectedItems.length === 0) {
        alert('Please select at least one item to add to cart.');
        return;
      }

      const parentProductTitle = bundleContainer.dataset.parentProductTitle || 'Bundle';
      const parentProductImage = bundleContainer.dataset.parentProductImage || '';

      // Separate auto-add items from bundle items
      const autoAddVariantId = '55659677516121';
      const autoAddItem = selectedItems.find(item => item.id === autoAddVariantId);
      const bundleItems = selectedItems.filter(item => item.id !== autoAddVariantId);

      // Add bundle using _components approach (without auto-add item)
      await this.addBundleWithComponents(parentVariantId, bundleItems, parentProductTitle, parentProductImage);

      // Add auto-add item as separate cart item (if exists)
      if (autoAddItem) {
        await this.addAutoAddItemToCart(autoAddItem);
      }

      // Show success message
      this.showSuccessMessage();

      // Reset button state
      this.updateAddToCartButtonState();

      // Redirect to cart after short delay (to show success message)
      setTimeout(() => {
        window.location.href = window.Shopify?.routes?.root ? window.Shopify.routes.root + 'cart' : '/cart';
      }, 1000);

    } catch (error) {
      console.error('Error adding items to cart:', error);
      alert('There was an error adding items to cart. Please try again.');
    } finally {
      // Re-enable button
      button.disabled = false;
      button.textContent = 'Add to Cart';
    }
  }

  // Handle personalization input changes with auto-add variant
  handlePersonalizationInput(inputElement) {
    const autoAddVariantId = inputElement.dataset.autoAddVariant;
    const autoAddQuantity = parseInt(inputElement.dataset.autoAddQuantity) || 1;
    const hasText = inputElement.value.trim().length > 0;

    // Only proceed if auto-add is configured
    if (!autoAddVariantId) return;

    // Store auto-add state on the input element
    const isAutoAdded = inputElement.dataset.autoAdded === 'true';

    if (hasText && !isAutoAdded) {
      // User entered text - mark as auto-added
      inputElement.dataset.autoAdded = 'true';
      console.log(`Personalization text entered. Variant ${autoAddVariantId} (qty: ${autoAddQuantity}) will be auto-added to bundle.`);
    } else if (!hasText && isAutoAdded) {
      // User cleared text - remove auto-added flag
      inputElement.dataset.autoAdded = 'false';
      console.log(`Personalization text cleared. Variant ${autoAddVariantId} will not be added.`);
    }
  }

  // Handle date/extra input changes with auto-add variant
  handleDateExtraInput(inputElement) {
    const autoAddVariantId = inputElement.dataset.autoAddVariant;
    const autoAddQuantity = parseInt(inputElement.dataset.autoAddQuantity) || 1;
    const hasText = inputElement.value.trim().length > 0;

    // Only proceed if auto-add is configured
    if (!autoAddVariantId) return;

    // Store auto-add state on the input element
    const isAutoAdded = inputElement.dataset.autoAdded === 'true';

    if (hasText && !isAutoAdded) {
      // User entered text - mark as auto-added
      inputElement.dataset.autoAdded = 'true';
      console.log(`Date/Extra info entered. Variant ${autoAddVariantId} (qty: ${autoAddQuantity}) will be auto-added to bundle.`);
    } else if (!hasText && isAutoAdded) {
      // User cleared text - remove auto-added flag
      inputElement.dataset.autoAdded = 'false';
      console.log(`Date/Extra info cleared. Variant ${autoAddVariantId} will not be added.`);
    }
  }

  collectSelectedItems(bundleContainer, parentVariantId = null) {
    const selectedItems = [];

    console.log('Collecting selected items...', { parentVariantId });

    // Collect regular bundle items
    const regularCheckboxes = bundleContainer.querySelectorAll('.bundle-product-checkbox:checked');
    console.log('Regular checkboxes found:', regularCheckboxes.length);
    regularCheckboxes.forEach(checkbox => {
      const variantId = checkbox.dataset.productId; // This is actually variant ID now
      const productHandle = checkbox.dataset.productHandle;

      // Find variant select that is sibling to this checkbox
      const bundleItem = checkbox.closest('.product-bundle__item');
      const variantSelect = bundleItem ? bundleItem.querySelector('.product-bundle__variant-select') : null;
      const productTitle = bundleItem ? bundleItem.querySelector('.product-bundle__product-title')?.textContent?.trim() : '';

      const selectedVariantId = variantSelect ? variantSelect.value : variantId;

      // Get selected variant title if available
      let variantTitle = '';
      let variantPrice = 0;

      // Check if variantSelect is a SELECT element or hidden INPUT
      if (variantSelect && variantSelect.tagName === 'SELECT' && variantSelect.selectedIndex >= 0) {
        const selectedOption = variantSelect.options[variantSelect.selectedIndex];
        variantTitle = selectedOption.textContent.trim();
        variantPrice = parseInt(selectedOption.dataset.price) || 0;
      } else if (variantSelect && variantSelect.tagName === 'INPUT' && variantSelect.type === 'hidden') {
        // Single variant product - no variant title needed
        variantTitle = '';
        // Try to get price from product card if available
        const priceElement = bundleItem ? bundleItem.querySelector('.price-list sale-price, .price-list .price') : null;
        if (priceElement) {
          const priceText = priceElement.textContent.replace(/[^0-9.]/g, '');
          variantPrice = Math.round(parseFloat(priceText) * 100);
        }
      }

      // Build attributes for variant options
      const attributes = {};
      if (variantTitle && variantTitle !== 'Default Title') {
        // Parse variant title (e.g., "0-3 months" or "Blue / Small")
        const variantParts = variantTitle.split('/').map(p => p.trim());
        if (variantParts.length === 1) {
          // Single option (likely "Size" or similar)
          attributes['Size'] = variantParts[0];
        } else {
          // Multiple options - we'll use generic names
          variantParts.forEach((part, index) => {
            attributes[`Option ${index + 1}`] = part;
          });
        }
      }

      selectedItems.push({
        id: selectedVariantId,
        quantity: 1,
        title: productTitle,
        parentVariantId: parentVariantId, // Add parent variant ID to each item
        properties: {
          'Bundle Item': 'Regular Bundle',
          'Product Handle': productHandle,
          ...attributes
        }
      });
    });

    // Collect customization items
    const customizationCheckboxes = bundleContainer.querySelectorAll('.bundle-customization-checkbox:checked');
    console.log('Customization checkboxes found:', customizationCheckboxes.length);
    customizationCheckboxes.forEach(checkbox => {
      const variantId = checkbox.dataset.productId; // This is actually variant ID now
      const productHandle = checkbox.dataset.productHandle;

      // Find customization options that are siblings to this checkbox
      const customizationItem = checkbox.closest('.product-bundle__customization-item');
      const fontSelect = customizationItem ? customizationItem.querySelector('.product-bundle__font-select') : null;
      const threadColorInput = customizationItem ? customizationItem.querySelector('.product-bundle__thread-color-input:checked') : null;
      const variantSelect = customizationItem ? customizationItem.querySelector('.product-bundle__variant-select') : null;
      const productTitle = customizationItem ? customizationItem.querySelector('.product-bundle__product-title')?.textContent?.trim() : '';

      const selectedVariantId = variantSelect ? variantSelect.value : variantId;

      const properties = {
        'Bundle Item': 'Customization',
        'Product Handle': productHandle
      };

      if (fontSelect && fontSelect.value) {
        properties['Font'] = fontSelect.value;
      }

      if (threadColorInput) {
        properties['Thread Color'] = threadColorInput.value;
      }

      console.log('Adding customization item:', {
        id: selectedVariantId,
        quantity: 1,
        title: productTitle,
        parentVariantId: parentVariantId,
        properties: properties
      });

      selectedItems.push({
        id: selectedVariantId,
        quantity: 1,
        title: productTitle,
        parentVariantId: parentVariantId, // Add parent variant ID to each item
        properties: properties
      });
    });

    // Collect product options (step_1, bundle_2, bundle_3 and bundle_4)
    // Items are auto-selected when a product is chosen from dropdown (no checkbox required)
    const productSelects = bundleContainer.querySelectorAll('.product-bundle__product-select');
    productSelects.forEach(productSelect => {
      // Only include if a product is actually selected
      if (!productSelect.value || productSelect.value === '') return;

      const optionGroup = productSelect.dataset.optionGroup;
      const threadColorInput = bundleContainer.querySelector(`[data-option-group="${optionGroup}"].product-bundle__thread-color-input:checked`);
      const iconInput = bundleContainer.querySelector(`.product-bundle__icon-input[data-option-group="${optionGroup}"]:checked`);
      const personalizationInput = bundleContainer.querySelector(`[data-option-group="${optionGroup}"].product-bundle__personalization-input`);

      if (productSelect && productSelect.value) {
        // Get product title from select option
        const selectedOption = productSelect.options[productSelect.selectedIndex];
        const productTitle = selectedOption?.dataset?.productTitle || selectedOption?.textContent?.split(' - ')[0]?.trim() || '';
        const optionVariantTitle = (selectedOption?.dataset?.variantTitle || '').trim();

        // Default to the variant referenced in the select option
        let finalVariantId = productSelect.value;
        let variantTitle = optionVariantTitle;

        // Allow any step to provide its own variant selector (step_1 uses a dedicated class)
        const variantSelectStep1 = bundleContainer.querySelector(`[data-option-group="${optionGroup}"].product-bundle__variant-select-step1`);
        const variantSelectGeneric = bundleContainer.querySelector(`[data-option-group="${optionGroup}"].product-bundle__variant-select`);
        const variantSelect = variantSelectStep1 || variantSelectGeneric;

        if (variantSelect && variantSelect.value) {
          finalVariantId = variantSelect.value;
          const variantOption = variantSelect.options[variantSelect.selectedIndex];
          variantTitle = variantOption?.textContent?.trim() || variantTitle;
        }

        const properties = {
          'Bundle Item': 'Product Option',
          'Option Group': optionGroup
        };

        // Add variant title as Size attribute if available
        if (variantTitle && variantTitle !== 'Default Title' && !variantTitle.includes('Sold out')) {
          properties['Size'] = variantTitle;
        }

        if (threadColorInput) {
          // Get the label from the selected color option
          const colorLabel = threadColorInput.closest('.product-bundle__thread-color-option')
            .querySelector('.product-bundle__thread-color-name').textContent;
          properties['Thread Color'] = `${colorLabel} (${threadColorInput.value})`;
        }

        // Add font selection if available
        const fontSelect = bundleContainer.querySelector(`[data-option-group="${optionGroup}"].product-bundle__font-select`);
        if (fontSelect && fontSelect.value) {
          properties['Font'] = fontSelect.value;
        }

        // Add position selection if available
        const positionSelect = bundleContainer.querySelector(`[data-option-group="${optionGroup}"].product-bundle__position-select`);
        if (positionSelect && positionSelect.value) {
          properties['Position of Name'] = positionSelect.value;
        }

        // Add name option inputs if available
        const nameOptionInputs = bundleContainer.querySelectorAll(`[data-option-group="${optionGroup}"].product-bundle__name-option-input`);
        nameOptionInputs.forEach(input => {
          if (input.value.trim()) {
            const optionName = input.dataset.optionName;
            properties[optionName] = input.value.trim();
          }
        });

        // Add initial input if available
        const initialInput = bundleContainer.querySelector(`[data-option-group="${optionGroup}"].product-bundle__initial-input`);
        if (initialInput && initialInput.value.trim()) {
          properties['Initial'] = initialInput.value.trim().toUpperCase();
        }

        if (iconInput) {
          // Get the icon title from the selected icon option
          const iconOption = iconInput.closest('.product-bundle__icon-option');
          const iconTitle = iconOption?.querySelector('.product-bundle__icon-title')?.textContent;
          if (iconTitle) {
            properties['Selected Icon'] = iconTitle;
          }
        }

        // Add thread icon if available (no cost)
        const threadIconInput = bundleContainer.querySelector(`.product-bundle__thread-icon-input[data-option-group="${optionGroup}"]:checked`);
        if (threadIconInput) {
          const threadIconOption = threadIconInput.closest('.product-bundle__thread-icon-option');
          const threadIconTitle = threadIconOption?.querySelector('.product-bundle__thread-icon-title')?.textContent;
          if (threadIconTitle) {
            properties['Thread Icon'] = threadIconTitle;
          }
        }

        if (personalizationInput && personalizationInput.value.trim()) {
          properties['Personalization'] = personalizationInput.value.trim();
        }

        // Add date/extra data if available
        const dateExtraInput = bundleContainer.querySelector(`[data-option-group="${optionGroup}"].product-bundle__date-extra-input`);
        if (dateExtraInput && dateExtraInput.value.trim()) {
          properties['Date / Extra Info'] = dateExtraInput.value.trim();
        }

        selectedItems.push({
          id: finalVariantId,
          quantity: 1,
          title: productTitle,
          parentVariantId: parentVariantId, // Add parent variant ID to each item
          properties: properties
        });
      }
    });

    // Calculate total quantity needed for auto-add variant from all personalization fields
    let totalAutoAddQuantity = 0;
    const autoAddReasons = [];

    // Check personalization inputs
    const personalizationInputs = bundleContainer.querySelectorAll('.product-bundle__personalization-input[data-auto-add-variant]');
    personalizationInputs.forEach(input => {
      const hasText = input.value.trim().length > 0;
      const autoAddQuantity = parseInt(input.dataset.autoAddQuantity) || 0;

      if (hasText && autoAddQuantity > 0) {
        const optionGroup = input.dataset.optionGroup;
        totalAutoAddQuantity += autoAddQuantity;
        autoAddReasons.push(`Personalization in ${optionGroup}: "${input.value.trim()}" (+${autoAddQuantity})`);
        console.log(`Personalization (${optionGroup}): +${autoAddQuantity} units`);
      }
    });

    // Check date/extra inputs
    const dateExtraInputs = bundleContainer.querySelectorAll('.product-bundle__date-extra-input[data-auto-add-variant]');
    dateExtraInputs.forEach(input => {
      const hasText = input.value.trim().length > 0;
      const autoAddQuantity = parseInt(input.dataset.autoAddQuantity) || 0;

      if (hasText && autoAddQuantity > 0) {
        const optionGroup = input.dataset.optionGroup;
        totalAutoAddQuantity += autoAddQuantity;
        autoAddReasons.push(`Date/Extra Info in ${optionGroup}: "${input.value.trim()}" (+${autoAddQuantity})`);
        console.log(`Date/Extra Info (${optionGroup}): +${autoAddQuantity} units`);
      }
    });

    // Check icon selections
    const iconInputs = bundleContainer.querySelectorAll('.product-bundle__icon-input[data-auto-add-variant]:checked');
    iconInputs.forEach(input => {
      const iconPrice = parseInt(input.dataset.iconPrice) || 0;
      const autoAddQuantity = parseInt(input.dataset.autoAddQuantity) || 0;

      if (autoAddQuantity > 0) {
        const iconName = input.value;
        const optionGroup = input.dataset.optionGroup;
        totalAutoAddQuantity += autoAddQuantity;
        autoAddReasons.push(`Icon "${iconName}" in ${optionGroup} (+${autoAddQuantity})`);
        console.log(`Icon (${optionGroup}): +${autoAddQuantity} units for ${iconName}`);
      }
    });

    // Add the variant once with combined quantity at the end
    if (totalAutoAddQuantity > 0) {
      const autoAddVariantId = '55659677516121';

      console.log(`Adding auto-add variant ${autoAddVariantId} with total quantity: ${totalAutoAddQuantity}`);
      console.log('Reasons:', autoAddReasons);

      // No properties - add as a clean product
      selectedItems.push({
        id: autoAddVariantId,
        quantity: totalAutoAddQuantity,
        title: 'Embroidery Thread'
        // No properties or parent - standalone cart item
      });
    }

    console.log('Total selected items collected:', selectedItems.length);
    console.log('Selected items:', selectedItems);

    return selectedItems;
  }

  // Get parent variant ID from bundle container or product form
  getParentVariantId(bundleContainer) {
    // First try to get from data attribute (updated when variant changes)
    let parentVariantId = bundleContainer.dataset.parentVariantId;

    // If not found, try to get from the product form
    if (!parentVariantId) {
      const formId = bundleContainer.dataset.bundleForm;
      if (formId) {
        const productForm = document.getElementById(formId);
        if (productForm) {
          const variantInput = productForm.querySelector('[name="id"]');
          if (variantInput) {
            parentVariantId = variantInput.value;
          }
        }
      }
    }

    return parentVariantId;
  }

  // Add auto-add item as separate cart item (not part of bundle)
  async addAutoAddItemToCart(autoAddItem) {
    console.log('=== Adding Auto-Add Item as Separate Cart Item ===');
    console.log('Auto-Add Item:', autoAddItem);

    // Build item without properties for clean cart line item
    const item = {
      'id': parseInt(autoAddItem.id),
      'quantity': autoAddItem.quantity
    };

    const formData = {
      'items': [item]
    };

    console.log('Auto-Add Request:', JSON.stringify(formData, null, 2));

    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error('Failed to add auto-add item:', errorData);
        throw new Error(errorData.message || 'Failed to add auto-add item to cart');
      }

      const result = await response.json();
      console.log('Auto-add item added to cart successfully:', result);

      return result;

    } catch (error) {
      console.error('Error adding auto-add item to cart:', error);
      throw error;
    }
  }

  // Add bundle using _components approach
  async addBundleWithComponents(parentVariantId, bundleItems, bundleTitle = 'Bundle', bundleImage = '') {
    console.log('=== Building Bundle Components ===');
    console.log('Parent Variant ID:', parentVariantId);
    console.log('Bundle Items Count:', bundleItems.length);
    console.log('Raw Bundle Items:', bundleItems);

    // Format bundle items as components
    const components = bundleItems.map((item, index) => {
      console.log(`\n--- Processing Item ${index + 1} ---`);
      console.log('Item ID:', item.id);
      console.log('Item Title:', item.title);
      console.log('Item Parent Variant ID:', item.parentVariantId || 'Not set');
      console.log('Item Properties:', item.properties);

      const component = {
        'id': parseInt(item.id),
        'quantity': item.quantity || 1
      };

      // Add only meaningful attributes (variant options and customizations)
      // Exclude meta properties like "Bundle Item", "Product Handle", "Bundle Type"
      if (item.properties && Object.keys(item.properties).length > 0) {
        const attributes = {};
        const excludedKeys = ['Bundle Item', 'Product Handle', 'Bundle Type', 'Option Group'];

        Object.keys(item.properties).forEach(key => {
          if (!excludedKeys.includes(key)) {
            console.log(`  Adding attribute: ${key} = ${item.properties[key]}`);
            attributes[key] = item.properties[key];
          } else {
            console.log(`  Excluding meta key: ${key}`);
          }
        });

        // Only add attributes if there are any
        if (Object.keys(attributes).length > 0) {
          component.attributes = attributes;
          console.log('  Final attributes:', attributes);
        } else {
          console.log('  No attributes to add');
        }
      }

      console.log('  Final component:', component);
      return component;
    });

    console.log('\n=== All Components ===');
    console.log(JSON.stringify(components, null, 2));

    // Build line item properties
    const lineItemProperties = {
      '_components': JSON.stringify(components)
    };

    console.log('\n=== Building Item Titles ===');
    // Add individual item titles to properties (for display in cart)
    bundleItems.forEach((item, index) => {
      // Get the base product title
      let itemTitle = item.title || `Item ${index + 1}`;

      // Build the corresponding component to get its attributes
      const component = components[index];

      // If there are attributes, format them as "Key: Value" pairs
      if (component.attributes && Object.keys(component.attributes).length > 0) {
        const attributePairs = Object.entries(component.attributes).map(([key, value]) => {
          return `${key}: ${value}`;
        });
        const attributeString = attributePairs.join(' / ');
        itemTitle = `${itemTitle} - ${attributeString}`;
        console.log(`Item ${index + 1} title with attributes:`, itemTitle);
      } else {
        console.log(`Item ${index + 1} title without attributes:`, itemTitle);
      }

      lineItemProperties[`Item ${index + 1}`] = itemTitle;
    });

    // Add bundle settings
    const settings = {};
    if (bundleTitle) {
      settings.title = bundleTitle;
    }
    if (bundleImage) {
      settings.image = bundleImage;
    }

    if (Object.keys(settings).length > 0) {
      lineItemProperties['_settings'] = JSON.stringify(settings);
    }

    console.log('\n=== Line Item Properties ===');
    console.log(JSON.stringify(lineItemProperties, null, 2));

    // Build the cart add request
    const formData = {
      'items': [
        {
          'id': parseInt(parentVariantId),
          'quantity': 1,
          'properties': lineItemProperties
        }
      ]
    };

    console.log('\n=== Final Cart Add Request ===');
    console.log(JSON.stringify(formData, null, 2));
    console.log('\n=== Request Body (what will be sent) ===');
    console.log(JSON.stringify(formData));

    try {
      const requestBody = JSON.stringify(formData);
      console.log('\n Sending request to:', window.Shopify.routes.root + 'cart/add.js');
      console.log('Request body:', requestBody);

      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: requestBody
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error('Failed to add bundle:', errorData);
        throw new Error(errorData.message || 'Failed to add bundle to cart');
      }

      const result = await response.json();
      console.log(' Bundle added to cart successfully:', result);

      return result;

    } catch (error) {
      console.error('Error adding bundle to cart:', error);
      throw error;
    }
  }

  // Add main product to cart as parent
  async addMainProductToCart(productId) {
    // First check if the main product already exists in cart
    const existingParent = await this.findExistingParentInCart(productId);
    if (existingParent) {
      console.log('Main product already in cart, using existing:', existingParent);
      return existingParent;
    }

    const formData = {
      'items': [{
        'id': productId,
        'quantity': 1,
        'properties': {
          'Bundle Type': 'Main Product'
        }
      }]
    };

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to add main product to cart');
      }

      const result = await response.json();
      console.log('Main product added to cart:', result);

      // Return the cart line key for nested items
      return {
        key: result.key,
        id: result.id
      };

    } catch (error) {
      console.error('Error adding main product to cart:', error);
      throw error;
    }
  }

  // Find existing parent product in cart
  async findExistingParentInCart(productId) {
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) {
        return null;
      }

      const cart = await response.json();
      const parentItem = cart.items.find(item =>
        item.variant_id == productId &&
        item.properties &&
        item.properties['Bundle Type'] === 'Main Product'
      );

      if (parentItem) {
        return {
          key: parentItem.key,
          id: parentItem.id
        };
      }

      return null;
    } catch (error) {
      console.error('Error checking existing cart:', error);
      return null;
    }
  }

  // Add nested item to cart with parent relationship
  async addNestedItemToCart(item, parentKey) {
    const formData = {
      'items': [{
        'id': item.id,
        'quantity': item.quantity,
        'properties': {
          ...item.properties,
          'Bundle Type': 'Bundle Item'
        },
        'parent_line_key': parentKey
      }]
    };

    console.log('Sending nested cart request:', JSON.stringify(formData, null, 2));

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error('Failed to add nested item:', errorData);
        throw new Error(errorData.message || 'Failed to add nested item to cart');
      }

      const result = await response.json();
      console.log('Nested item added to cart:', result);
      console.log('Parent relationship in response:', result.parent_relationship);
      return result;

    } catch (error) {
      console.error('Error adding nested item to cart:', error);
      throw error;
    }
  }

  async addItemToCart(item) {
    const formData = {
      'items': [{
        'id': item.id,
        'quantity': item.quantity,
        'properties': item.properties
      }]
    };

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to add item to cart');
      }

      return await response.json();
    } catch (error) {
      console.error('Error adding item to cart:', error);
      throw error;
    }
  }

  showSuccessMessage() {
    // Create a temporary success message
    const message = document.createElement('div');
    message.className = 'bundle-success-message';
    message.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: #4CAF50;
      color: white;
      padding: 15px 20px;
      border-radius: 5px;
      z-index: 1000;
      font-weight: bold;
      box-shadow: 0 4px 6px rgba(0,0,0,0.1);
    `;
    message.textContent = 'Successfully added to cart!';

    document.body.appendChild(message);

    // Remove message after 3 seconds
    setTimeout(() => {
      if (message.parentNode) {
        message.parentNode.removeChild(message);
      }
    }, 3000);
  }

  // Handle product selection from dropdown
  async handleProductSelection(selectElement) {
    const optionGroup = selectElement.dataset.optionGroup;
    const selectedVariantId = selectElement.value;
    const selectedOption = selectElement.options[selectElement.selectedIndex];

    console.log('Product selection changed:', {
      optionGroup,
      selectedVariantId,
      selectedOption
    });

    if (!selectedVariantId) {
      // Hide selected product display
      const selectedProductDiv = document.querySelector(`[data-option-group="${optionGroup}"].product-bundle__selected-product`);
      if (selectedProductDiv) {
        selectedProductDiv.style.display = 'none';
      }
      return;
    }

    // Get product data from the selected option
    const productId = selectedOption.dataset.productId;
    const productHandle = selectedOption.dataset.productHandle;
    const productTitle = selectedOption.dataset.productTitle;
    const productPrice = selectedOption.dataset.productPrice;
    const productImage = selectedOption.dataset.productImage;
    const hasVariants = selectedOption.dataset.hasVariants === 'true';
    const variantsJson = selectedOption.dataset.variantsJson;
    const isAvailable = selectedOption.dataset.available === 'true';

    console.log('Product data:', {
      productId,
      productHandle,
      productTitle,
      productPrice,
      productImage,
      hasVariants
    });

      // Show selected product display
    const selectedProductDiv = document.querySelector(`[data-option-group="${optionGroup}"].product-bundle__selected-product`);
    if (selectedProductDiv) {
      selectedProductDiv.style.display = 'block';

      // Handle out of stock products
      const checkbox = selectedProductDiv.querySelector('.bundle-option-checkbox');
      if (!isAvailable) {
        // Grey out the entire product display
        selectedProductDiv.classList.add('out-of-stock');
        // Disable checkbox
        if (checkbox) {
          checkbox.disabled = true;
          checkbox.checked = false;
        }
      } else {
        // Enable for in-stock products
        selectedProductDiv.classList.remove('out-of-stock');
        if (checkbox) {
          checkbox.disabled = false;
        }
      }

      // Update product info
      const titleElement = selectedProductDiv.querySelector('.product-bundle__selected-product-title');
      const priceElement = selectedProductDiv.querySelector('.product-bundle__selected-product-price');
      const imageElement = selectedProductDiv.querySelector('.product-bundle__selected-product-image');

      if (titleElement) {
        titleElement.textContent = productTitle;
      }

      if (priceElement) {
        if (isAvailable) {

          priceElement.classList.remove('out-of-stock');
        } else {
          priceElement.innerHTML = `<span class="out-of-stock-badge">Out of Stock</span>`;
          priceElement.classList.add('out-of-stock');
        }
      }

      // Display product image
      if (imageElement) {
        if (productImage && productImage !== '') {
          // Convert to Shopify CDN URL if needed
          const imageUrl = this.convertToShopifyCDN(productImage);
          imageElement.innerHTML = `<img src="${imageUrl}" alt="${productTitle}" loading="lazy">`;
        } else if (productHandle) {
          // Fallback: fetch product data if image URL not provided
          try {
            const productData = await this.fetchProductData(productHandle);
            if (productData && productData.featured_image) {
              imageElement.innerHTML = `<img src="${productData.featured_image}" alt="${productTitle}" loading="lazy">`;
            }
          } catch (error) {
            console.error('Error fetching product image:', error);
          }
        }
      }

      // Handle variant selection for all option groups
      if (hasVariants && variantsJson) {
        const variantSelection = selectedProductDiv.querySelector('.product-bundle__variant-selection');
        const variantSelect = optionGroup === 'step_1'
          ? selectedProductDiv.querySelector('.product-bundle__variant-select-step1')
          : selectedProductDiv.querySelector('.product-bundle__variant-select');

        if (variantSelection && variantSelect) {
          try {
            const variants = JSON.parse(variantsJson);
            variantSelect.innerHTML = '';

            variants.forEach(variant => {
              const option = document.createElement('option');
              option.value = variant.id;
              option.textContent = variant.title;
              option.dataset.price = variant.price;
              option.dataset.comparePrice = variant.compare_at_price || '';
              option.dataset.available = variant.available ? 'true' : 'false';

              if (!variant.available) {
                option.disabled = true;
                option.textContent += ' (Sold out)';
              }
              variantSelect.appendChild(option);
            });

            variantSelection.style.display = 'block';

            // Update price and summary when variant changes
            variantSelect.addEventListener('change', (e) => {
              const selectedVariantOption = e.target.options[e.target.selectedIndex];
              const newPrice = selectedVariantOption.dataset.price;
              const variantAvailable = selectedVariantOption.dataset.available === 'true';

              if (priceElement && newPrice) {
                if (variantAvailable) {
                  priceElement.textContent = this.formatPrice(newPrice);
                  priceElement.classList.remove('out-of-stock');
                } else {
                  priceElement.innerHTML = `${this.formatPrice(newPrice)} <span class="out-of-stock-badge">Out of Stock</span>`;
                  priceElement.classList.add('out-of-stock');
                }
              }

              // Update checkbox availability based on variant stock
              const checkbox = selectedProductDiv.querySelector('.bundle-option-checkbox');
              if (checkbox) {
                if (variantAvailable) {
                  checkbox.disabled = false;
                  selectedProductDiv.classList.remove('out-of-stock');
                } else {
                  checkbox.disabled = true;
                  checkbox.checked = false;
                  selectedProductDiv.classList.add('out-of-stock');
                }
              }

              // Update the bundle summary with new variant/price
              this.updateBundleSummary();
            });

          } catch (error) {
            console.error('Error parsing variants JSON:', error);
            variantSelection.style.display = 'none';
          }
        }
      }

      console.log('Product display updated successfully');
    }
  }

  // Fetch product data from Shopify
  async fetchProductData(productHandle) {
    try {
      const response = await fetch(`/products/${productHandle}.js`);
      if (!response.ok) {
        throw new Error('Failed to fetch product data');
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching product data:', error);
      return null;
    }
  }

  // Format price for display
  formatPrice(price) {
    const priceInCents = parseInt(price);
    const priceInDollars = (priceInCents / 100).toFixed(2);

    // Get shop currency symbol
    const currencySymbol = this.getCurrencySymbol();

    return `${currencySymbol}${priceInDollars}`;
  }

  // Get shop currency symbol
  getCurrencySymbol() {
    // Try to get from Shopify currency settings
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      const currency = window.Shopify.currency.active;
      const currencySymbols = {
        'USD': '$',
        'EUR': '€',
        'GBP': '£',
        'CAD': '$',
        'AUD': '$',
        'JPY': '¥',
        'CNY': '¥',
        'INR': '₹',
        'SEK': 'kr',
        'NOK': 'kr',
        'DKK': 'kr',
        'CHF': 'CHF',
        'PLN': 'zł',
        'CZK': 'Kč',
        'HUF': 'Ft',
        'RUB': '₽'
      };
      return currencySymbols[currency] || currency + ' ';
    }

    // Fallback: try to get from theme currency
    if (window.theme && window.theme.moneyFormat) {
      // Extract symbol from money format (e.g., "€{{amount}}" -> "€")
      const match = window.theme.moneyFormat.match(/^([^{]+)/);
      if (match) {
        return match[1].trim();
      }
    }

    // Final fallback
    return '€';
  }

  // Convert image path to Shopify CDN URL
  convertToShopifyCDN(imagePath) {
    if (!imagePath) return '';

    // If it's already a full URL, return as is
    if (imagePath.startsWith('http://') || imagePath.startsWith('https://') || imagePath.startsWith('//')) {
      return imagePath;
    }

    // Get shop domain from Shopify object or current location
    let shopDomain = '';
    if (window.Shopify && window.Shopify.shop) {
      shopDomain = window.Shopify.shop;
    } else {
      shopDomain = window.location.hostname;
    }

    // If it starts with 'files/' or 'products/', prepend CDN domain
    if (imagePath.startsWith('files/') || imagePath.startsWith('products/')) {
      // Use the current domain's CDN
      return `https://${shopDomain}/cdn/shop/${imagePath}`;
    }

    // If it's just a filename without path, assume it's in files
    if (!imagePath.includes('/')) {
      return `https://${shopDomain}/cdn/shop/files/${imagePath}`;
    }

    // Default: prepend current domain
    return `https://${shopDomain}${imagePath.startsWith('/') ? '' : '/'}${imagePath}`;
  }


  // Handle product selection from dropdown
  selectProductFromDropdown(dropdown) {
    const bundleContainer = document.querySelector('.product-bundle');
    if (!bundleContainer) return;

    const selectedIndex = parseInt(dropdown.value);
    const products = bundleContainer.querySelectorAll('.product-bundle__item');

    if (selectedIndex < 0 || selectedIndex >= products.length) return;

    // Hide all products
    products.forEach(product => {
      product.style.display = 'none';
    });

    // Show selected product
    const selectedProduct = products[selectedIndex];
    selectedProduct.style.display = 'block';

    // Reset any selections for the new product
    this.resetProductSelections(selectedProduct);
  }

  // Reset product selections when navigating
  resetProductSelections(productElement) {
    // Uncheck the checkbox
    const checkbox = productElement.querySelector('.bundle-product-checkbox');
    if (checkbox) {
      checkbox.checked = false;
    }

    // Hide variants
    const variants = productElement.querySelector('.product-bundle__variants');
    if (variants) {
      variants.style.display = 'none';
    }

    // Reset quantity to 1
    const quantityInput = productElement.querySelector('.bundle-quantity-input');
    if (quantityInput) {
      quantityInput.value = 1;
    }

    // Update button state
    this.updateAddToCartButtonState();
  }

  // Initialize parent variant listener
  initializeParentVariantListener() {
    const bundleContainer = document.querySelector('.product-bundle');
    if (!bundleContainer) return;

    const formId = bundleContainer.dataset.bundleForm;
    if (!formId) return;

    const productForm = document.getElementById(formId);
    if (!productForm) return;

    // Listen for variant changes on the product form
    const variantInput = productForm.querySelector('[name="id"]');
    if (variantInput) {
      // Set initial value
      const initialVariantId = variantInput.value;
      if (initialVariantId) {
        bundleContainer.dataset.parentVariantId = initialVariantId;
        console.log('Initial parent variant ID set to:', initialVariantId);
      }

      // Update on change
      const observer = new MutationObserver(() => {
        const newVariantId = variantInput.value;
        if (newVariantId) {
          bundleContainer.dataset.parentVariantId = newVariantId;
          console.log('Parent variant updated via MutationObserver to:', newVariantId);
        }
      });

      observer.observe(variantInput, {
        attributes: true,
        attributeFilter: ['value']
      });

      // Also listen for direct changes
      variantInput.addEventListener('change', () => {
        const newVariantId = variantInput.value;
        if (newVariantId) {
          bundleContainer.dataset.parentVariantId = newVariantId;
          console.log('Parent variant changed via event listener to:', newVariantId);
        }
      });
    }

    // Also listen for variant:change events (theme-specific)
    document.addEventListener('variant:change', (e) => {
      if (e.detail && e.detail.variant && e.detail.variant.id) {
        bundleContainer.dataset.parentVariantId = e.detail.variant.id;
        console.log('Parent variant changed via variant:change event to:', e.detail.variant.id);
      }
    });
  }

  // Initialize product selector
  initializeProductSelector() {
    const bundleContainer = document.querySelector('.product-bundle');
    if (!bundleContainer) return;

    const products = bundleContainer.querySelectorAll('.product-bundle__item');
    const dropdown = bundleContainer.querySelector('.product-bundle__product-dropdown');

    if (products.length <= 1) {
      // Hide dropdown if only one product
      const selector = bundleContainer.querySelector('.product-bundle__product-selector');
      if (selector) {
        selector.style.display = 'none';
      }
      return;
    }

    // Ensure first product is selected and visible
    if (dropdown && products.length > 0) {
      dropdown.value = '0';
      products.forEach((product, index) => {
        product.style.display = index === 0 ? 'block' : 'none';
      });
    }
  }

  // Initialize step wizard
  initializeStepWizard() {
    const bundleContainer = document.querySelector('.product-bundle');
    if (!bundleContainer) return;

    const steps = bundleContainer.querySelectorAll('.product-bundle__step');
    this.totalSteps = steps.length;

    if (steps.length === 0) {
      console.log('No bundle steps found');
      return;
    }

    // Hide all steps except the first
    steps.forEach((step, index) => {
      if (index === 0) {
        step.style.display = 'block';
        step.style.visibility = 'visible';
        step.style.opacity = '1';
      } else {
        step.style.display = 'none';
      }
    });

    // Ensure step 1 is visible using data-step attribute as backup
    const step1 = bundleContainer.querySelector('.product-bundle__step[data-step="1"]');
    if (step1) {
      step1.style.display = 'block';
      step1.style.visibility = 'visible';
      step1.style.opacity = '1';
    }

    // Update step indicators
    this.updateStepIndicators();
  }

  // Go to next step
  goToNextStep() {
    const bundleContainer = document.querySelector('.product-bundle');
    if (!bundleContainer) return;

    const steps = bundleContainer.querySelectorAll('.product-bundle__step');
    if (this.currentStep >= this.totalSteps) return;

    // Validate that a product is selected in the current step
    const currentStepElement = bundleContainer.querySelector(`.product-bundle__step[data-step="${this.currentStep}"]`);
    if (currentStepElement) {
      const productSelect = currentStepElement.querySelector('.product-bundle__product-select');

      if (productSelect) {
        // Check if a product is actually selected
        if (!productSelect.value || productSelect.value === '') {
          // Show error message
          this.showStepValidationError(currentStepElement, 'Please select a product before continuing');
          return;
        }

        // Check if product requires variant selection
        const variantSelect = currentStepElement.querySelector('.product-bundle__variant-selection');
        if (variantSelect && variantSelect.style.display !== 'none') {
          const variantSelectInput = currentStepElement.querySelector('.product-bundle__variant-select, .product-bundle__variant-select-step1');
          if (variantSelectInput && (!variantSelectInput.value || variantSelectInput.value === '')) {
            this.showStepValidationError(currentStepElement, 'Please select a variant before continuing');
            return;
          }
        }
      }

      // Hide current step
      currentStepElement.style.display = 'none';
      // Remove any error messages
      this.hideStepValidationError(currentStepElement);
    }

    // Show next step
    this.currentStep++;
    const nextStepElement = bundleContainer.querySelector(`.product-bundle__step[data-step="${this.currentStep}"]`);
    if (nextStepElement) {
      nextStepElement.style.display = 'block';
      // Scroll to top of step
      nextStepElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    // Update indicators
    this.updateStepIndicators();
  }

  // Go to previous step
  goToPreviousStep() {
    const bundleContainer = document.querySelector('.product-bundle');
    if (!bundleContainer) return;

    if (this.currentStep <= 1) return;

    // Hide current step
    const currentStepElement = bundleContainer.querySelector(`.product-bundle__step[data-step="${this.currentStep}"]`);
    if (currentStepElement) {
      currentStepElement.style.display = 'none';
    }

    // Show previous step
    this.currentStep--;
    const prevStepElement = bundleContainer.querySelector(`.product-bundle__step[data-step="${this.currentStep}"]`);
    if (prevStepElement) {
      prevStepElement.style.display = 'block';
      // Scroll to top of step
      prevStepElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    // Update indicators
    this.updateStepIndicators();
  }

  // Show validation error in current step
  showStepValidationError(stepElement, message) {
    // Remove any existing error
    this.hideStepValidationError(stepElement);

    // Create error message element
    const errorDiv = document.createElement('div');
    errorDiv.className = 'product-bundle__step-validation-error';
    errorDiv.style.cssText = `
      background-color: #fef2f2;
      border: 1px solid #fecaca;
      color: #991b1b;
      padding: 12px 16px;
      border-radius: 6px;
      margin: 16px 0;
      font-size: 14px;
      font-weight: 500;
      display: flex;
      align-items: center;
      gap: 8px;
    `;

    errorDiv.innerHTML = `
      <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/>
      </svg>
      <span>${message}</span>
    `;

    // Insert error at the top of the step
    const stepTitle = stepElement.querySelector('.product-bundle__step-title');
    if (stepTitle && stepTitle.nextSibling) {
      stepTitle.parentNode.insertBefore(errorDiv, stepTitle.nextSibling);
    } else {
      stepElement.insertBefore(errorDiv, stepElement.firstChild);
    }

    // Scroll to error
    errorDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  // Hide validation error
  hideStepValidationError(stepElement) {
    const existingError = stepElement.querySelector('.product-bundle__step-validation-error');
    if (existingError) {
      existingError.remove();
    }
  }

  // Show review step (final step with summary)
  showReviewStep() {
    const bundleContainer = document.querySelector('.product-bundle');
    if (!bundleContainer) return;

    // Validate that a product is selected in the current step
    const currentStepElement = bundleContainer.querySelector(`.product-bundle__step[data-step="${this.currentStep}"]`);
    if (currentStepElement) {
      const productSelect = currentStepElement.querySelector('.product-bundle__product-select');

      if (productSelect) {
        // Check if a product is actually selected
        if (!productSelect.value || productSelect.value === '') {
          this.showStepValidationError(currentStepElement, 'Please select a product before continuing');
          return;
        }

        // Check if product requires variant selection
        const variantSelect = currentStepElement.querySelector('.product-bundle__variant-selection');
        if (variantSelect && variantSelect.style.display !== 'none') {
          const variantSelectInput = currentStepElement.querySelector('.product-bundle__variant-select, .product-bundle__variant-select-step1');
          if (variantSelectInput && (!variantSelectInput.value || variantSelectInput.value === '')) {
            this.showStepValidationError(currentStepElement, 'Please select a variant before continuing');
            return;
          }
        }
      }
    }

    // Hide all steps
    const steps = bundleContainer.querySelectorAll('.product-bundle__step');
    steps.forEach(step => {
      step.style.display = 'none';
    });

    // Show add to cart button
    const actions = bundleContainer.querySelector('.product-bundle__actions');
    if (actions) {
      actions.style.display = 'block';
    }

    // Update summary (it's already visible)
    this.updateBundleSummary();

    // Mark all steps as completed
    const stepIndicators = bundleContainer.querySelectorAll('.product-bundle__step-item');
    stepIndicators.forEach(indicator => {
      indicator.classList.add('completed');
      indicator.classList.remove('active');
    });

    // Scroll to summary
    const summary = bundleContainer.querySelector('.product-bundle__summary');
    if (summary) {
      summary.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  // Update step indicators
  updateStepIndicators() {
    const bundleContainer = document.querySelector('.product-bundle');
    if (!bundleContainer) return;

    const stepIndicators = bundleContainer.querySelectorAll('.product-bundle__step-item');

    stepIndicators.forEach(indicator => {
      const stepNumber = parseInt(indicator.dataset.step);

      // Remove all classes first
      indicator.classList.remove('active', 'completed');

      // Add appropriate class
      if (stepNumber === this.currentStep) {
        indicator.classList.add('active');
      } else if (stepNumber < this.currentStep) {
        indicator.classList.add('completed');
      }
    });
  }

  // Update bundle summary
  updateBundleSummary() {
    const bundleContainer = document.querySelector('.product-bundle');
    if (!bundleContainer) return;

    const summaryItems = bundleContainer.querySelector('.product-bundle__summary-items');
    if (!summaryItems) return;

    // Clear existing summary
    summaryItems.innerHTML = '';

    let totalPrice = 0;
    let totalItems = 0;

    // Add regular bundle items
    const regularCheckboxes = bundleContainer.querySelectorAll('.bundle-product-checkbox:checked');
    regularCheckboxes.forEach(checkbox => {
      const bundleItem = checkbox.closest('.product-bundle__item');
      if (!bundleItem) return;

      const title = bundleItem.querySelector('.product-bundle__product-title')?.textContent || 'Product';
      const variantSelect = bundleItem.querySelector('.product-bundle__variant-select');

      let variant = '';
      let price = 0;

      // Check if variantSelect is a SELECT element or hidden INPUT
      if (variantSelect && variantSelect.tagName === 'SELECT' && variantSelect.selectedIndex >= 0) {
        variant = variantSelect.options[variantSelect.selectedIndex]?.text || '';
        const priceData = variantSelect.options[variantSelect.selectedIndex]?.dataset?.price;
        price = priceData ? parseInt(priceData) : 0;
      } else if (variantSelect && variantSelect.tagName === 'INPUT' && variantSelect.type === 'hidden') {
        // Single variant product - get price from product card
        const priceElement = bundleItem.querySelector('.price-list sale-price, .price-list .price');
        if (priceElement) {
          const priceText = priceElement.textContent.replace(/[^0-9.]/g, '');
          price = Math.round(parseFloat(priceText) * 100);
        }
      }

      totalPrice += price;
      totalItems++;

      summaryItems.innerHTML += `
        <div class="product-bundle__summary-item">
          <span>${title}${variant ? ` - ${variant}` : ''}</span>
          <span>${this.getCurrencySymbol()}${(price / 100).toFixed(2)}</span>
        </div>
      `;
    });

    // Add customization items
    const customizationCheckboxes = bundleContainer.querySelectorAll('.bundle-customization-checkbox:checked');
    customizationCheckboxes.forEach(checkbox => {
      const customizationItem = checkbox.closest('.product-bundle__customization-item');
      if (!customizationItem) return;

      const title = customizationItem.querySelector('.product-bundle__product-title')?.textContent || 'Customization';
      const variantSelect = customizationItem.querySelector('.product-bundle__variant-select');
      const fontSelect = customizationItem.querySelector('.product-bundle__font-select');
      const threadColorInput = customizationItem.querySelector('.product-bundle__thread-color-input:checked');

      let variant = '';
      let price = 0;

      // Check if variantSelect is a SELECT element or hidden INPUT
      if (variantSelect && variantSelect.tagName === 'SELECT' && variantSelect.selectedIndex >= 0) {
        variant = variantSelect.options[variantSelect.selectedIndex]?.text || '';
        const priceData = variantSelect.options[variantSelect.selectedIndex]?.dataset?.price;
        price = priceData ? parseInt(priceData) : 0;
      } else if (variantSelect && variantSelect.tagName === 'INPUT' && variantSelect.type === 'hidden') {
        // Single variant product - get price from product card
        const priceElement = customizationItem.querySelector('.price-list sale-price, .price-list .price');
        if (priceElement) {
          const priceText = priceElement.textContent.replace(/[^0-9.]/g, '');
          price = Math.round(parseFloat(priceText) * 100);
        }
      }

      totalPrice += price;
      totalItems++;

      let customizationDetails = '';
      if (fontSelect?.value) {
        customizationDetails += ` | Font: ${fontSelect.value}`;
      }
      if (threadColorInput?.value) {
        customizationDetails += ` | Color: ${threadColorInput.value}`;
      }

      summaryItems.innerHTML += `
        <div class="product-bundle__summary-item">
          <span>${title}${variant ? ` - ${variant}` : ''}${customizationDetails}</span>
          <span>${this.getCurrencySymbol()}${(price / 100).toFixed(2)}</span>
        </div>
      `;
    });

    // Add product options (auto-selected when product is chosen)
    const productSelects = bundleContainer.querySelectorAll('.product-bundle__product-select');
    productSelects.forEach(productSelect => {
      // Only include if a product is actually selected
      if (!productSelect.value || productSelect.value === '') return;

      const optionGroup = productSelect.dataset.optionGroup;
      if (!optionGroup) return;
      const threadColorInput = bundleContainer.querySelector(`[data-option-group="${optionGroup}"].product-bundle__thread-color-input:checked`);
      const iconInput = bundleContainer.querySelector(`.product-bundle__icon-input[data-option-group="${optionGroup}"]:checked`);
      const personalizationInput = bundleContainer.querySelector(`[data-option-group="${optionGroup}"].product-bundle__personalization-input`);

      if (productSelect && productSelect.value && productSelect.selectedIndex >= 0) {
        const selectedOption = productSelect.options[productSelect.selectedIndex];
        if (!selectedOption) return;

        // Skip out of stock products
        const isAvailable = selectedOption.dataset?.available === 'true';
        if (!isAvailable) {
          console.warn('Skipping out of stock product:', selectedOption.dataset?.productTitle);
          return;
        }

        const title = selectedOption.dataset?.productTitle || 'Product Option';
        let price = selectedOption.dataset?.productPrice ? parseInt(selectedOption.dataset.productPrice) : 0;
        let variantText = '';
        let finalVariantId = productSelect.value;

        // Check if there's a variant selector for this option group
        const variantSelectClass = optionGroup === 'step_1'
          ? '.product-bundle__variant-select-step1'
          : '.product-bundle__variant-select';
        const variantSelect = bundleContainer.querySelector(`[data-option-group="${optionGroup}"]${variantSelectClass}`);

        if (variantSelect && variantSelect.value && variantSelect.selectedIndex >= 0) {
          const variantOption = variantSelect.options[variantSelect.selectedIndex];
          finalVariantId = variantSelect.value;
          const variantTitle = variantOption.textContent.trim();

          if (variantTitle && !variantTitle.includes('Sold out')) {
            variantText = ` - ${variantTitle}`;
          }

          const variantPrice = variantOption.dataset?.price;
          if (variantPrice) {
            price = parseInt(variantPrice);
          }
        }

        if (!variantText && selectedOption?.dataset?.variantTitle) {
          const datasetVariantTitle = selectedOption.dataset.variantTitle.trim();
          if (datasetVariantTitle && !datasetVariantTitle.includes('Sold out')) {
            variantText = ` - ${datasetVariantTitle}`;
          }
        }

        totalPrice += price;
        totalItems++;

        let optionDetails = '';

        // Check for font selection
        const fontSelect = bundleContainer.querySelector(`[data-option-group="${optionGroup}"].product-bundle__font-select`);
        if (fontSelect && fontSelect.value) {
          optionDetails += ` | Font: ${fontSelect.value}`;
        }

        // Check for position selection
        const positionSelect = bundleContainer.querySelector(`[data-option-group="${optionGroup}"].product-bundle__position-select`);
        if (positionSelect && positionSelect.value) {
          optionDetails += ` | Position: ${positionSelect.value}`;
        }

        if (iconInput) {
          const iconOption = iconInput.closest('.product-bundle__icon-option');
          const iconTitle = iconOption?.querySelector('.product-bundle__icon-title')?.textContent;
          if (iconTitle) {
            optionDetails += ` | Icon: ${iconTitle}`;
          }
        }
        if (threadColorInput) {
          const colorOption = threadColorInput.closest('.product-bundle__thread-color-option');
          const colorLabel = colorOption?.querySelector('.product-bundle__thread-color-name')?.textContent;
          if (colorLabel) {
            optionDetails += ` | Color: ${colorLabel}`;
          }
        }
        if (personalizationInput && personalizationInput.value.trim()) {
          optionDetails += ` | "${personalizationInput.value.trim()}"`;
        }

        // Check for date/extra data input
        const dateExtraInput = bundleContainer.querySelector(`[data-option-group="${optionGroup}"].product-bundle__date-extra-input`);
        if (dateExtraInput && dateExtraInput.value.trim()) {
          optionDetails += ` | Date/Info: "${dateExtraInput.value.trim()}"`;
        }

        // Check for name option inputs
        const nameOptionInputs = bundleContainer.querySelectorAll(`[data-option-group="${optionGroup}"].product-bundle__name-option-input`);
        nameOptionInputs.forEach(input => {
          if (input.value.trim()) {
            const optionName = input.dataset.optionName;
            optionDetails += ` | ${optionName}: "${input.value.trim()}"`;
          }
        });

        // Check for initial input
        const initialInput = bundleContainer.querySelector(`[data-option-group="${optionGroup}"].product-bundle__initial-input`);
        if (initialInput && initialInput.value.trim()) {
          optionDetails += ` | Initial: "${initialInput.value.trim().toUpperCase()}"`;
        }

        // Check for thread icon selection (no cost)
        const threadIconInput = bundleContainer.querySelector(`.product-bundle__thread-icon-input[data-option-group="${optionGroup}"]:checked`);
        if (threadIconInput) {
          const threadIconOption = threadIconInput.closest('.product-bundle__thread-icon-option');
          const threadIconTitle = threadIconOption?.querySelector('.product-bundle__thread-icon-title')?.textContent;
          if (threadIconTitle) {
            optionDetails += ` | Thread Icon: ${threadIconTitle}`;
          }
        }

        summaryItems.innerHTML += `
          <div class="product-bundle__summary-item">
            <span>${title}${variantText}${optionDetails}</span>
            <span>${this.getCurrencySymbol()}${(price / 100).toFixed(2)}</span>
          </div>
        `;
      }
    });

    // Calculate total auto-add quantity from all personalization fields
    let totalAutoAddQuantity = 0;
    const autoAddDetails = [];

    // Check personalization inputs
    const personalizationInputs = bundleContainer.querySelectorAll('.product-bundle__personalization-input[data-auto-add-variant]');
    personalizationInputs.forEach(input => {
      const hasText = input.value.trim().length > 0;
      const autoAddQuantity = parseInt(input.dataset.autoAddQuantity) || 0;

      if (hasText && autoAddQuantity > 0) {
        totalAutoAddQuantity += autoAddQuantity;
        autoAddDetails.push(`+${autoAddQuantity} for personalization`);
      }
    });

    // Check date/extra inputs
    const dateExtraInputs = bundleContainer.querySelectorAll('.product-bundle__date-extra-input[data-auto-add-variant]');
    dateExtraInputs.forEach(input => {
      const hasText = input.value.trim().length > 0;
      const autoAddQuantity = parseInt(input.dataset.autoAddQuantity) || 0;

      if (hasText && autoAddQuantity > 0) {
        totalAutoAddQuantity += autoAddQuantity;
        autoAddDetails.push(`+${autoAddQuantity} for date/extra info`);
      }
    });

    // Check icon selections
    const iconInputs = bundleContainer.querySelectorAll('.product-bundle__icon-input[data-auto-add-variant]:checked');
    iconInputs.forEach(input => {
      const iconPrice = parseInt(input.dataset.iconPrice) || 0;
      const autoAddQuantity = parseInt(input.dataset.autoAddQuantity) || 0;

      if (autoAddQuantity > 0) {
        const iconName = input.value;
        totalAutoAddQuantity += autoAddQuantity;
        autoAddDetails.push(`+${autoAddQuantity} for icon "${iconName}"`);
      }
    });

    // Add combined auto-add item to summary
    if (totalAutoAddQuantity > 0) {
      totalItems += totalAutoAddQuantity;

      const detailsText = autoAddDetails.length > 0 ? ` <em>(${autoAddDetails.join(', ')})</em>` : '';

      summaryItems.innerHTML += `
        <div class="product-bundle__summary-item product-bundle__summary-item--auto-add">
          <span>Embroidery Thread (×${totalAutoAddQuantity})${detailsText}</span>
          <span>Included</span>
        </div>
      `;
    }

    // Show empty message if no items
    if (totalItems === 0) {
      summaryItems.innerHTML = '<p class="product-bundle__summary-empty">No items selected yet. Start by selecting products from Step 1!</p>';
    }

    // Update item count
    const itemCountElement = bundleContainer.querySelector('.bundle-items-count');
    if (itemCountElement) {
      itemCountElement.textContent = totalItems;
    }

    // Update total price
    //const totalElement = bundleContainer.querySelector('.bundle-total-price');
    //if (totalElement) {
     // totalElement.textContent = `$${(totalPrice / 100).toFixed(2)}`;
    //}
  }

  // Back to steps from review
  backToSteps() {
    const bundleContainer = document.querySelector('.product-bundle');
    if (!bundleContainer) return;

    // Hide actions
    const actions = bundleContainer.querySelector('.product-bundle__actions');
    if (actions) {
      actions.style.display = 'none';
    }

    // Go back to last step
    this.currentStep = this.totalSteps;
    const lastStepElement = bundleContainer.querySelector(`.product-bundle__step[data-step="${this.currentStep}"]`);
    if (lastStepElement) {
      lastStepElement.style.display = 'block';
      lastStepElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    // Update indicators
    this.updateStepIndicators();
  }

  // Public method for debugging - can be called from console
  refreshButtonState() {
    this.updateAddToCartButtonState();
  }
}

// Initialize Featured Product Handler when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  window.bundleHandler = new ProductBundleCustomizationHandler();
});
